exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedorSelect #nombreLista[data-v-10c2ea4f]{margin:2%;text-align:initial;font-size:.833vw;color:#646a6a}.contenedorSelect .md-field .md-input[data-v-10c2ea4f]{height:10px}.contenedorSelect .md-field[data-v-10c2ea4f]{min-height:0}.contenedorSelect input[data-v-10c2ea4f]{height:100px!important}.contenedorSelect .md-field.md-theme-default[data-v-10c2ea4f]:after{background-color:transparent}.contenedorSelect .md-menu.md-select[data-v-10c2ea4f]{flex:1;overflow:auto;z-index:2;text-align-last:center;border:1px solid;border-radius:13px}.contenedorSelect .md-field[data-v-10c2ea4f]:before{height:2vw;z-index:2;opacity:0;transform:scaleX(.12)}.contenedorSelect .md-focused[data-v-10c2ea4f]{color:#fff}@media screen and (max-width:1350px){.contenedorSelect #nombreLista[data-v-10c2ea4f]{font-size:12px;margin-bottom:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10c2ea4f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/ComponenteSelect/ComponenteSelect.scss
// module id = 850
// module chunks = 0